module.exports = {
  GA_TRACKING_ID: 'G-5YYCK6YRXD',
}
